var render, staticRenderFns
import script from "./FixedDialog.vue?vue&type=script&lang=js&"
export * from "./FixedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1318199c",
  null
  
)

export default component.exports